import { config } from '@/config/config';
import { api } from '@shared/services/baseApiClient';

export default class AssetService {
  public static async loadCodeSnippet(): Promise<string> {
    const url = config().webAssistantLoaderUrl;

    try {
      return await api.send<string>('GET', url, null, { useAuth: false });
    } catch (error) {
      console.error('Failed to load code snippet', error);
      return '';
    }
  }
}
